import apiService, { ApiService } from './ApiService';
import { apis } from '../utility/constants';
import { List, ListParams } from '../types/main';
import { ItemId, Scenes } from '../types/items';
import { transformList } from './transformer';

class ScenesService {
  private route = apis.scenes;

  constructor(private api: ApiService) {}

  list = (params: ListParams) => this.api
    .get<List<Scenes>>(this.route.list, params)
    .then(transformList);

  get = (id: ItemId) => this.api.get<Scenes>(`${this.route.list}/${id}`);

  template = () => this.api.get<Scenes>(`${this.route.list}/new`);

  save = (id: ItemId, { ref, permissions, ...scenes }: Scenes) => this.api.put(`${this.route.list}/${id}`, scenes);

  create = ({ id, ref, permissions, ...scenes }: Scenes) => this.api.post<Scenes>(this.route.list, scenes);

  delete = (id: ItemId) => this.api.delete(`${this.route.list}/${id}`);

  duplicate = ({ id, ...scenes } : Scenes) => this.api.post<Scenes>(`${this.route.list}/${id}/clone`, scenes);
}

export default new ScenesService(apiService);
